import { Component, OnInit } from "@angular/core";
import { GlobalVariable } from "app/global/global";
import { CentroMedicoService } from "app/services/centro-medico.service";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { MedicoService } from "app/services/medico.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NotificationComponent } from "app/shared/notification/notification.component";
import { environment } from "environments/environment.prod";
import { switchMap, map, catchError, tap } from "rxjs/operators";
import { SpinnerService } from "app/services/spinner.service";
import { MatDialog } from "@angular/material/dialog";
import { TerminosYCondicionesService } from "../../services/terminos.service";
import { TerminosYCondicionesDialogComponent } from "../../shared/terminos-ycondiciones-dialog/terminos-ycondiciones-dialog.component";
import { throwError } from "rxjs";
import { camposFaltantes } from "../../utils/form-errors.utils";

@Component({
  selector: "app-login-medico",
  templateUrl: "./login-medico.component.html",
  styleUrls: ["./login-medico.component.scss"],
})
export class LoginMedicoComponent implements OnInit {
  //
  VERSION: string = GlobalVariable.VERSION_FRONT;
  titulo_login: string = "Mail";
  imagen: string = "";
  loginForm = new FormGroup({
    datoingreso: new FormControl("", Validators.required),
    password: new FormControl("", Validators.required),
  });
  hidePassword = true;

  //
  constructor(
    private router: Router,
    private medicoService: MedicoService,
    private snackBar: MatSnackBar,
    private centroService: CentroMedicoService,
    private spinnerService: SpinnerService,
    private dialog: MatDialog,
    private terminosService: TerminosYCondicionesService
  ) {
    this.titulo_login =
      environment.MEDICO_LOGIN == "MAIL" ? "Mail" : "Número documento";
    this.spinnerService.mostrarSpinner();
    this.centroService.getCentroImagen().subscribe(
      (data) => {
        this.imagen = `${GlobalVariable.BASE_API_URL}storage/images/centro-medico/${data}`;
        this.spinnerService.ocultarSpinner();
      },
      (error) => {
        this.spinnerService.ocultarSpinner();
      }
    );
  }

  //
  ngOnInit(): void {}

  //
  openSnackBar(message: string, action: string) {
    this.snackBar.openFromComponent(NotificationComponent, {
      data: {
        message: message,
        action: action,
      },
      duration: 2500,
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: [action],
    });
  }

  login(event) {
    if (this.loginForm.invalid) {
      this.openSnackBar(camposFaltantes(this.loginForm, { datoingreso: this.titulo_login, password: "Password" }), "error");
      return;
    }
    this.spinnerService.mostrarSpinner();

    this.medicoService
      .login(event)
      .pipe(
        catchError((error) => {
          this.spinnerService.ocultarSpinner();
          this.openSnackBar(
            "Ingreso fallido: " + (error?.error?.error || ""),
            "error"
          );
          return throwError(() => error);
        })
      )
      .subscribe({
        next: (response: any) => {
          if (!response.tc_valido) {
            this.spinnerService.ocultarSpinner();
            this.manejarTerminosYCondiciones(response);
          } else {
            this.completarLogin(response);
          }
        },
        error: () => {
          this.medicoService.deleteDatosAutorizacion();
        },
      });
  }

  private manejarTerminosYCondiciones(response: any) {
    const dialogRef = this.dialog.open(TerminosYCondicionesDialogComponent, {
      width: "600px",
      disableClose: true,
      data: {
        tc: response.tc,
        primeraVez: response.tc_primera_vez,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.aceptado) {
        this.aceptarTerminosYCompletar(response);
      } else {
        this.openSnackBar(
          "Debe aceptar los términos y condiciones para continuar",
          "error"
        );
      }
    });
  }

  private aceptarTerminosYCompletar(response: any) {
    this.spinnerService.mostrarSpinner();

    this.terminosService
      .aceptarTerminos({
        tipo_usuario: response.tc.tipo_usuario,
        id: response.medicoId,
        tc_aceptado: response.tc.version,
      })
      .pipe(
        tap(() => {
          const dataToken = {
            token: response.token,
            medicoId: response.medicoId,
          };
          this.medicoService.handleData(dataToken);
        }),
        switchMap(() => this.medicoService.datosAutorizacion()),
        catchError((error) => {
          this.spinnerService.ocultarSpinner();
          this.openSnackBar(
            "Error al aceptar los términos y condiciones",
            "error"
          );
          return throwError(() => error);
        })
      )
      .subscribe({
        next: (data) => this.finalizarLogin(data),
        error: () => this.medicoService.deleteDatosAutorizacion(),
      });
  }

  private completarLogin(response: any) {
    const dataToken = { token: response.token, medicoId: response.medicoId };
    this.medicoService.handleData(dataToken);

    this.medicoService
      .datosAutorizacion()
      .pipe(
        catchError((error) => {
          this.spinnerService.ocultarSpinner();
          this.medicoService.deleteDatosAutorizacion();
          this.openSnackBar("Error al obtener datos de autorización", "error");
          return throwError(() => error);
        })
      )
      .subscribe((data) => this.finalizarLogin(data));
  }

  private finalizarLogin(data: any) {
    this.medicoService.setDatosAutorizacion(data);
    this.spinnerService.ocultarSpinner();
    this.router.navigate(["/seccion-medico/home-medico/"]);
  }
}
